import { NotificationType } from 'ha/modules/RealtimeMessaging/constants';

export default action =>
  action.payload.type === NotificationType.conversationMessage;
